export default function Builder(Client) {
    const local = {};
    const instance = {
        withName(name) {
            local.name = name;
            return instance;
        },
        withAlias(alias) {
            local.alias = alias;
            return instance;
        },
        withArgs(args) {
            local.args = args;
            return instance;
        },
        withSelection(selection) {
            local.selection = selection;
            return instance;
        },
        build() {
            if (!local.name) {
                throw new Error('Cannot build a query without a name. Use withName(name)');
            }
            return ({
                [local.alias || local.name]: (local.selection || local.args || local.alias) ? ({
                    alias: local.alias ? local.name : undefined,
                    args: local.args,
                    select: local.selection,
                }) : true,
            });
        },
        asQuery() {
            return Client.query(instance.build()).then((data) => data[local.alias || local.name]);
        },
        asMutation() {
            return Client.mutation(instance.build()).then((data) => data[local.alias || local.name]);
        },
        combineQueries(queries) {
            const queryDefinitions = queries.map((q) => q.build());
            const queryDefinition = queryDefinitions.reduce((def, query) => ({ ...def, ...query }), {});
            return Client.query(queryDefinition).then((data) => queryDefinitions.map((query) => {
                const alias = Object.keys(query)[0];
                return data[alias];
            }));
        },
        combineMutations(queries) {
            const queryDefinitions = queries.map((q) => q.build());
            const queryDefinition = queryDefinitions.reduce((def, query) => ({ ...def, ...query }), {});
            return Client.mutation(queryDefinition).then((data) => queryDefinitions.map((query) => {
                const alias = Object.keys(query)[0];
                return data[alias];
            }));
        },
    };
    return instance;
}
